module.exports = __webpack_public_path__ + "static/media/pic1.23ff118b.jpg";